


































import Vue from 'vue'
import { ButtonElInterface, YPayBoxElInterface, YPaySummaryElInterface } from '@/config/interfaces'
import YPayBoxEl from '@/components/elements/YPayBoxEl.vue'
import ButtonEl from '@/components/elements/ButtonEl.vue'

export default Vue.extend({
  name: 'YPaySummaryEl',
  components: { ButtonEl, YPayBoxEl },
  props: {
    templateItemData: {
      type: Object as () => YPaySummaryElInterface,
      required: true
    }
  },
  computed: {
    buttonData (): ButtonElInterface {
      const selectedBillValues: Array<string> = []

      this.templateItemData.list.forEach((el: YPayBoxElInterface) => {
        if (this.$store.getters.getBillValues.includes(el.getValue) && this.templateItemData.switchVisibility) {
          selectedBillValues.push(el.getValue)
        }
      })

      const url = new URL(this.templateItemData.total.uri)

      if (selectedBillValues.length > 0) {
        url.searchParams.set('param', selectedBillValues.join(','))
      }

      return {
        type: 'button',
        view: this.templateItemData.total.view,
        title: this.templateItemData.total.buttontext,
        inputReferences: [],
        uri: url.toString()
      }
    },
    total (): string {
      let sum = 0
      this.templateItemData.list.forEach((el: YPayBoxElInterface) => {
        if (this.$store.getters.getBillValues.includes(el.getValue) || !this.templateItemData.switchVisibility) {
          sum += Number(el.value)
        }
      })
      return sum.toFixed(2)
    }
  }
})
